export var PROJECT_STATE_TAG_TRANSLATION_KEY = 'project-state-tag';